// The menu-test comments block's props builders. It is the narrowest member of the family --
// quotes and cloud only -- behind a collapse strip no other type has: the strip is the controls
// bag's own title and toggle, the quotes drop their totals footer, and the cloud hides the
// answers table.

import { OE_PROPS_BUILDERS } from '@aytm/app/stats/page/question-views/oe/lib/props'
import { calcControlsProps as calcOeControlsProps } from '@aytm/app/stats/page/question-views/oe/lib/props/controls'
import { calcVerbatimProps as calcOeVerbatimProps } from '@aytm/app/stats/page/question-views/oe/lib/props/verbatim'
import { calcWcProps as calcOeWcProps } from '@aytm/app/stats/page/question-views/oe/lib/props/word-cloud'

const VERBATIM_FORMAT = { hideTotal: true }

export const MN_PROPS_BUILDERS = {
  ...OE_PROPS_BUILDERS,
  calcControlsProps: inputs => ({
    ...calcOeControlsProps(inputs),
    title: 'Comments',
    collapsed: inputs.collapsed,
    onToggle: inputs.handlers?.onToggle
  }),
  calcVerbatimProps: inputs => calcOeVerbatimProps({ ...inputs, verbatimFormat: VERBATIM_FORMAT }),
  calcWcProps: inputs => calcOeWcProps({ ...inputs, components: { ...(inputs.components || {}), table: false } })
}
